// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#InventoryMacbook .json-key{color:brown}#InventoryMacbook .json-value{color:navy}#InventoryMacbook .json-boolean{color:teal}#InventoryMacbook .json-string{color:olive}#InventoryMacbook .ajustefont{font-size:15px!important}#InventoryMacbook .keyItem{text-transform:uppercase}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
